<template>
    <content-view>
        <!-- 积分管理－新增会员等级页面 -->
        <div class="wrap-container-in">
            <a-form :form="form" class="level-form" @submit="handleSubmit" >
                <a-form-item label="积分区间" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                    <a-input-group compact >
                        <a-input-number class="age-input age-input-left" :defaultValue='0' disabled />
                        <a-input style="width: 42px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="至" disabled />
                        <a-input-number class="age-input age-input-left" placeholder="请输入" v-decorator="['maxVal',{rules: [{required: true, message: '请输入积分区间最大值',}]}]" />
                    </a-input-group>
                </a-form-item>
                <a-form-item label="会员等级" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                    <a-input placeholder="请输入" v-decorator="['grade',{rules: [{required: true, message: '请输入会员等级',}]}]" ></a-input>
                </a-form-item>
                <a-form-item label="会员名称" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                    <a-input placeholder="请输入" v-decorator="['name',{rules: [{required: true, message: '请输入会员名称',}]}]" ></a-input>
                </a-form-item>
                <a-form-item class="text-center">
                    <a-button @click="backPage">取消</a-button>
                    <a-button type="primary" html-type="submit" >确认</a-button>
                </a-form-item>
            </a-form>
        </div>
    </content-view>
</template>

<script type="text/javascript">
export default {
    name: "vipLevel",
    components: {},
    props: {},
    data() {
        return {
            labelCol: {span: 8},
            wrapperCol: {span: 10},
            row: {}
        };
    },
    computed: {},
    methods: {
        getDetail(id) {
            let valuesForm = {
                maxVal: this.row.maxVal,
                grade: this.row.grade,
                name: this.row.name,
            }
            this.form.setFieldsValue(valuesForm)
        },
        handleSubmit (e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    if(this.row) {
                        this.updateConfig(values)
                    }else {
                        this.addConfig(values)
                    }
                }
            });
        },
        addConfig(values) {
            this.$api.integral.addConfig({
                body: values
            })
            .then(res => {
                this.$message.success('操作成功', 2);
                this.backPage()
            })
        },
        updateConfig(values) {
            this.$api.integral.updatememberList({
                body: Object.assign(values,{id: this.row.id})
            })
            .then(res => {
                this.$message.success('操作成功', 2);
                this.backPage()
            })
        },
        backPage() {
            this.$router.push({ name: "grade" });
        }
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
    },
    created() {},
    mounted() {
        this.row = this.$route.query
        this.row && this.getDetail()
    },
};
</script>
<style lang="scss" scoped>
    .wrap-container-in {
        background-color: #fff;
        padding: 24px 32px;
        border-radius: 2px;
        .level-form {
            margin: 0 auto;
            .ant-input-number {
                width: 100%;
            }
            .age-input {
                width: calc(50% - 21px);
                text-align: center;
                &-right {
                    border-left: 0;
                }
            }
        }
    } 
</style>